import React from 'react';
import { FederatedApp } from "@dtsl/react-utils"
import { federatedAppData } from '../common';

const CommonHeaderImpl = () => {
	const env = ENVIRONMENT;
	const showHeaderContent = !(window?.account?.hideHeaderContent);

    const headerProps={
        env,
        isAppMFE: false,
        isBrevo: "true",
        isLogo: !showHeaderContent,
        content: showHeaderContent, // if content prop is false (Bool), it will display empty header variation (with Brevo logo and logout cta)
        appIdentity: "account-symfony"
    }

    const headerData=federatedAppData[env]["commonHeader"];

    return (
        <FederatedApp 
            appData={headerData}
            appProps={headerProps} 
            fallback={<></>}
        />

    )
}

export default CommonHeaderImpl;